import {NETWORK_URLS} from '../constants/NetworkConstants';
import { apiUrl, headerHelper } from '../helper/Utility'

export default class PaymentOptionsService {

  // GET PAYMENT OPTIONS

  static getData = async (token) => {
    var endpoint = NETWORK_URLS.get_payment_options;
    var encodedUrl = apiUrl() + endpoint;
    try {
      var response = await fetch(encodedUrl,{method: 'GET', headers: headerHelper(token)});
      var responseJson = await response.json();
      return responseJson;
    } catch (e) {
      console.log(e);
      return [];
    }
  }  

}
